import moment from 'moment-timezone';

export const statusLabels = {
  AUTHORIZED: 'Autorizada',
  CANCELLED: 'Cancelada',
};

export const manifestationLabels = {
  ACKNOWLEDGED: 'Ciente',
  CONFIRMED: 'Confirmada',
  UNKNOWN_OPERATION: 'Desconhecida',
  NOT_PERFORMED: 'Não realizada',
};

export const purposeLabels = {
  NORMAL: 'Normal',
  COMPLEMENTARY: 'Complementar',
  ADJUSTMENT: 'Ajuste',
  RETURN: 'Devolução',
};

export const taxRegimeLabels = {
  1: 'Simples Nacional',
  2: 'Simples Nacional (excesso de sublimite)',
  3: 'Regime normal',
  4: 'MEI',
};

export const classificationLabels = {
  PURCHASE: 'Compra',
  BONUS: 'Bonificação',
  FUTURE_DELIVERY_BILLING: 'Faturamento entrega futura',
  THIRD_PARTY_REMITTANCE: 'Remessa por conta e ordem',
  RETURN: 'Devolução',
  REVIEW: 'Revisar',
};

export const taxLabels = {
  ICMS: 'ICMS',
  ICMS_ST: 'ICMS ST',
  ICMS_ST_RETAINED: 'ICMS ST retido',
  ICMS_SN_CREDIT: 'Crédito ICMS Simples',
  ICMS_DESONERADO: 'ICMS desonerado',
  FCP: 'FCP',
  FCP_ST: 'FCP ST',
  IPI: 'IPI',
  PIS: 'PIS',
  COFINS: 'COFINS',
  CBS: 'CBS',
  IBS_STATE: 'IBS estadual',
  IBS_MUNICIPAL: 'IBS municipal',
  SELECTIVE_TAX: 'Imposto Seletivo',
};

export const outcomeLabels = {
  IMPORTED: 'Importada',
  ALREADY_IMPORTED: 'Já importada',
  UPDATED: 'Atualizada',
  EVENT_RECORDED: 'Evento registrado',
  SKIPPED_OWN_INVOICE: 'Nota própria (ignorada)',
  REJECTED: 'Rejeitada',
};

export const reconciliationIssueLabels = {
  DETAILS_PENDING: 'Aguardando dados do Bling',
  NO_INVOICE_LINKED: 'Sem nota vinculada',
  INVOICE_NOT_FOUND: 'Nota não importada',
  AMBIGUOUS_INVOICE: 'Mais de uma nota com o número',
  CANCELLED_INVOICE: 'Nota cancelada',
  DISREGARDED_INVOICE: 'Nota desconsiderada',
  TOTAL_MISMATCH: 'Total diferente da nota',
  BONUS_MISMATCH: 'Bonificação divergente',
  ORDERS_IN_DIFFERENT_MONTHS: 'Nota com pedidos atendidos em meses diferentes',
  ITEMS_PENDING_MATCH: 'Itens sem produto',
  QUANTITY_MISMATCH: 'Quantidade diferente do pedido',
};

export const matchStatusLabels = {
  PENDING: 'Sem produto',
  MATCHED: 'Vinculado',
  IGNORED: 'Não é produto',
  DISREGARDED: 'Desconsiderado',
};

export const supplierCodeSourceLabels = {
  BARCODE: 'Aprendido pelo código de barras',
  MANUAL: 'Definido na conciliação',
};

// Mirrors the backend: 8, 12 or 13 digits, or 14 starting with 0 (others are case codes), with a valid check digit
export const isProductGtin = (code) => {
  const acceptedLength = [8, 12, 13].includes(code.length) || (code.length === 14 && code[0] === '0');
  if (!acceptedLength || !/^\d+$/.test(code)) return false;

  const digits = code.split('').map(Number);
  const weightedSum = digits.slice(0, -1).reverse()
    .reduce((sum, digit, index) => sum + (index % 2 === 0 ? digit * 3 : digit), 0);

  return (10 - (weightedSum % 10)) % 10 === digits[digits.length - 1];
};

export const formatNcm = ncm => (ncm ? ncm.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1.$2.$3') : '');

export const formatCest = cest => (cest ? cest.replace(/^(\d{2})(\d{3})(\d{2})$/, '$1.$2.$3') : '');

// Segment 28 is for goods sold door to door, which Magenta doesn't do; some suppliers state it anyway
export const isDoorToDoorCest = cest => Boolean(cest && cest.startsWith('28'));

export const formatDateTime = value => (value ? moment(value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm') : '');

const currencyFormat = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const numberFormat = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 4 });

export const formatCurrency = value => (value === null || value === undefined ? '' : currencyFormat.format(value));

export const formatNumber = value => (value === null || value === undefined ? '' : numberFormat.format(value));

export const formatDate = value => (value ? moment(value).tz('America/Sao_Paulo').format('DD/MM/YYYY') : '');

export const formatDocument = (value) => {
  if (!value) return '';
  if (value.length === 14) return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  if (value.length === 11) return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  return value;
};
